import styled from 'styled-components'
import { transparentize } from 'polished'
import { font } from 'lib/core/resources/helpers/styled'

export const Container: any = styled.div`
  position: absolute;
  left: 0;
  top: ${(props: any) => 26 + ((props.position - 1) * 44)}px;
  height: 34px;
  overflow-x: hidden;
  padding-top: 2px;
  padding-left: 0;
`

export const Wrapper: any = styled.label`
  background-color: ${(props: any) => props.sale ? props.theme.palette.primary.beta : props.theme.palette.primary.alpha};
  color: ${props => props.theme.palette.general.light};
  font: ${font('default', 'bold', '14px/1')};
  text-transform: uppercase;
  padding: 4px 32px;
  box-shadow: 0 2px 4px 0 ${props => transparentize(0.5, props.theme.palette.general.dark)};
  position: relative;
  z-index: 1;
`

export const Arrow: any = styled.div`
  transform: rotate(-27deg);
  width: 20px;
  height: 20px;
  background-color: ${(props: any) => props.sale ? props.theme.palette.primary.beta : props.theme.palette.primary.alpha};
  position: absolute;
  top: 8px;
  left: -5px;
`
